import Vue from 'vue'
import Router from 'vue-router'

import { setPageTitleMiddleware, resetScrollMiddleware } from './middlewares'
import { routes } from './routes'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
})

router.beforeEach(setPageTitleMiddleware)
router.afterEach(resetScrollMiddleware)

export default router
